module.exports = __webpack_public_path__ + "img/_super_05.8d8e23ba.jpg";